import { Type } from '@sinclair/typebox';
import { StakeholdersWithoutOrgIdSchema } from './stakeholders/stakeholders.js';
export var ProjectOrganisationType;
(function (ProjectOrganisationType) {
    ProjectOrganisationType["CESG"] = "CESG";
    ProjectOrganisationType["CUSTOMER"] = "CUSTOMER";
    ProjectOrganisationType["UE"] = "UE";
    ProjectOrganisationType["PROJEKTORER"] = "PROJEKTORER";
})(ProjectOrganisationType || (ProjectOrganisationType = {}));
// -- BASE ---
const ProjectOrganisationBaseSchema = Type.Object({
    id: Type.String(),
    projectId: Type.String(),
});
const StrictProjectOrganisationTypes = Type.Object({
    name: Type.Enum(ProjectOrganisationType),
});
const LaxProjectOrganisationTypes = Type.Object({
    name: Type.String(),
});
export const SelectProjectOrganisationSchema = Type.Intersect([
    ProjectOrganisationBaseSchema,
    LaxProjectOrganisationTypes,
]);
export const UpdateProjectOrganisationSchema = Type.Partial(Type.Intersect([ProjectOrganisationBaseSchema, StrictProjectOrganisationTypes]));
export const CreateProjectOrganisationSchema = Type.Intersect([
    Type.Omit(ProjectOrganisationBaseSchema, ['id']),
    StrictProjectOrganisationTypes,
]);
export const OrganisationWithStakeholdersSchemaWithoutPID = Type.Omit(SelectProjectOrganisationSchema, ['projectId']);
// --- JOIN ---
export const OrganisationWithStakeholdersSchema = Type.Intersect([
    SelectProjectOrganisationSchema,
    Type.Object({
        stakeholders: Type.Array(StakeholdersWithoutOrgIdSchema),
    }),
]);
